export const OBSERVER_OPTIONS = {
  threshold: 0.5,
}

export const INFINITE_ITEMS_LOAD_ON_SCROLL_THRESHOLD_INDEX_FROM_LIST_END = 2
